const homeServicesData=[
    {
        id:1,
        title:"Profesyonel Kamera Güvenlik Sistemleri",
        icon:11,
        desci:" ",
        to:"/ProfesyonelKamera"
    },
    {
        id:2,
        title:"Akıllı Ev Sistemleri",
        icon:12,
        desci:" ",
        to:"/BlogAkilliev"
    },
    {
        id:3,
        title:"Hırsız Alarm Sistemleri",
        icon:13,
        desci:" ",
        to:"/AlarmSistemleri"
    },
    {
        id:4,
        title:"Yangın Alarm Sistemleri",
        icon:14,
        desci:" ",
        to:"/AlarmSistemleri"
    },
    {
        id:5,
        title:"Alarm İzleme Merkezi",
        icon:15,
        desci:" ",
        to:"/AlarmSistemleri"
    },
    {
        id:6,
        title:"Kontrollü Geçiş Sistemleri",
        icon:16,
        desci:" ",
        to:"/GecisSistemleri"
    },
    {
        id:7,
        title:"Personel Takip Sistemleri",
        icon:17,
        desci:" ",
        to:"/PersonelTakipSistemleri"
    },
    {
        id:8,
        title:"Ses ve Işık Sistemleri",
        icon:18,
        desci:" ",
        to:""
    },
    {
        id:9,
        title:"Otomasyon Sistemleri",
        icon:19,
        desci:" ",
        to:""
    },
    {
        id:10,
        title:"Plaka Tanıma Sistemleri",
        icon:20,
        desci:" ",
        to:""
    },
    
    {
        id:12,
        title:"Hemşire Çağrı Sistemleri",
        icon:21,
        desci:" ",
        to:""
    },
    {
        id:13,
        title:"Yazılım Çözümleri",
        icon:22,
        desci:" ",
        to:"/NetworkSistemleri"
    },
    {
        id:14,
        title:"Sinema Sistemleri",
        icon:23,
        desci:" ",
        to:""
    },
    {
        id:15,
        title:"KVKK Çözümleri",
        icon:24,
        desci:" ",
        to:"/NetworkSistemleri"
    },
    {
        id:16,
        title:"Dijital Medya Çözümleri",
        icon:25,
        desci:" ",
        to:""
    },
    {
        id:17,
        title:"Güneş Enerji Sistemleri",
        icon:26,
        desci:" ",
        to:""
    },
    

]
export default homeServicesData;